import React, { useEffect, useRef, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Autocomplete, Box, Breadcrumbs, Card, CardContent, FormControl, Grid, InputAdornment, List, OutlinedInput, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, IconButton, Collapse } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ApprovedIcon from "../assets/icon/Approved.png";
import DeniedIcon from "../assets/icon/Denied.png";
import Navbar from "../components/Navbar";
import {
  ConvertDate,
  GetErrorMessageFromResponse,
  GetTime,
  ITCatalogOrderXMLCompomnent,
  UTCToCurrentTimeZone,
} from "../common/commonFunction";
import { useConfirmPopup } from "../components/context/confirmation-context";
import { useSnackBar } from "../components/context/snackbar-context";
import Loader from "../components/common components/Loader";
import PendingRequestThreeDots from "../components/PendingRequestThreeDots";
import { NavLink, useSearchParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { userStore } from "../store/store";
import ShowNotes from "../components/ShowNotes";
import { UserRequestListService } from "./../services/UserRequestListService";
import PendingRequestItemsKenbanMenu from "./../components/PendingRequestItemsKenbanMenu";
import InfoIcon from "@mui/icons-material/Info";
import ShowItemFormData from "../components/modelPopup/ShowItemFormData";
import NoteIcon from "../assets/icon/notes.png";
import { processRequestItems } from "../common/utils";
import { GridCheckIcon, GridCloseIcon } from "@mui/x-data-grid";
import { ref } from "yup";

const PendingApprovals = () => {
  const [approveAdditionalInfo, setApproveAdditionalInfo] = useState('');
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [approveRequestId, setApproveRequestId] = useState<any>(null);
  const [approveItem, setApproveItem] = useState<any>(null);
  const [approveCreatedUserName, setApproveCreatedUserName] = useState<string>('');
  const [isLoading, setIsloading] = useState(true);
  const [selectedRequestNotes, SetSelectedRequestNotes] = useState<any>([]);
  const [selectedItemFormDetails, SetSelectedItemFormDetails] = useState<any>([]);
  const [selectedItemDetails, SetselectedItemDetails] = useState<any>();
  const [selectedRequestId, SetselectedRequestId] = useState<any>();
  const [OpenShowNotePopup, SetOpenShowNotePopup] = useState(false);
  const [OpenShowItemDetailsPopup, SetOpenShowItemDetailsPopup] = useState(false);
  const [pendingRequests, setPendingRequests] = React.useState<any>([]);
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
  const filteredPendingRequests = pendingRequests;
  const handleExpandClick = (requestId: string) => {
    setExpandedRows((prev) => ({ ...prev, [requestId]: !prev[requestId] }));
  };
  const snackbar = useSnackBar();
  const confirmPopupService = useConfirmPopup();
  const uStore: any = userStore();
  const [expandedRequestItems, setExpandedRequestItems] = useState<any[]>([]);
  const [denyDialogOpen, setDenyDialogOpen] = useState(false);
  const [denyReason, setDenyReason] = useState('');
  const [denyRequestId, setDenyRequestId] = useState<any>(null);
  const [denyItem, setDenyItem] = useState<any>(null);
  const refreshPendingApprovalsRef = useRef<() => void>();

  const deniedItemOfRequest = (
    requestId: any, item: any,
    deniedReason: string, handleCloseDialog: () => void) => {
    UserRequestListService.ChangeCurrentRequestItemStatus(
      requestId,
      item.requestItemID,
      item,
      "Denied",
      uStore.getUser().userEmail,
            deniedReason
          )
        .then((res: any) => {
          if (res) {
            handleCloseDialog();
            if (res.data.code === 200 && res.data.data === "success") {
              snackbar.showSnackBar(
                "Request item has been denied successfully.",
                "success"
              );
              if (refreshPendingApprovalsRef.current) {
                refreshPendingApprovalsRef.current();
              }
            } else if (res.data.code === 404) {
              snackbar.showSnackBar(res.data.data, "error");
            } else if (res.data.code === 400) {
              snackbar.showSnackBar(res.data.data, "error");
            } else {
              snackbar.showSnackBar(
                "Request has not been denied successfully.",
                "error"
              );
            }
          }
        })
        .catch((err) => {
          handleCloseDialog();
          snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
        });
  };

  const approveItemOfRequest = (
      requestId: any,
      item: any,
      newStatus: string,
      CreatedUserName: string,
      additonalInfo: any = null
    ) => {
      let items = [];
      items.push(item);
  
      let problemTypeValue = "";
      let descriptionValue = item.description;
      if (item.category.id === 1) {
        problemTypeValue = "Hardware Request";
      } else if (item.category.id === 2) {
        problemTypeValue = "Software Request_New Software";
        if (item.formData) {
          try {
            const formDataObj = JSON.parse(item.formData);
            if (formDataObj && formDataObj["Details"]) {
              descriptionValue = formDataObj["Details"] + "\nRequest User: " + CreatedUserName;
            }
          } catch {}
        }
      } else if (item.category.id === 4) {
        problemTypeValue = "Employee Lifecycle";
      }

  
      const numWeeks = 2;
      const now = new Date();
      now.setDate(now.getDate() + numWeeks * 7);
  
      const SysAidpayload: any = {
        info: [
          { key: "due_date", value: now.getTime().toString() },
          { key: "status", value: "2" },
          { key: "problem_type", value: problemTypeValue },
          { key: "description", value: descriptionValue },
          { key: "CustomColumn93sr", value: CreatedUserName },
          { key: "request_user_name", value: CreatedUserName },
          {
            key: "notes",
            value: [],
          },
        ],
      };

      if (item.category.id === 2) {
        SysAidpayload.info.push({ key: "title", value: item.description });
      }
  
      if (item.formData) {
        let formDataValue = JSON.parse(item.formData);
        var formDataValueResultArrayObject: any = Object.keys(formDataValue).map(
          function (key) {
            if (additonalInfo && key === "CustomColumn74sr") {
              return { key: key, value: additonalInfo };
            } else {
              return { key: key, value: formDataValue[key] };
            }
          }
        );
        if (item.sysAidTemplateId) {
          formDataValueResultArrayObject.map((obj: any) => {
            SysAidpayload.info.push(obj);
          });
        }
      }
  
      const cXMlRequestPayload = ITCatalogOrderXMLCompomnent(
        items,
        uStore.getUser().firstName + " " + uStore.getUser().lastName,
        uStore.getUser().userEmail
      );
      UserRequestListService.ChangeCurrentRequestItemStatus(
        requestId,
        item.requestItemID,
        item,
        newStatus,
        uStore.getUser().userEmail,
        null,
        cXMlRequestPayload,
        JSON.stringify(SysAidpayload),
        additonalInfo
      )
        .then((res: any) => {
          if (res) {
            if (res.data.code === 200 && res.data.data === "success") {
              snackbar.showSnackBar(
                "Request item has been approved successfully.",
                "success"
              );
              if (refreshPendingApprovalsRef.current) {
                refreshPendingApprovalsRef.current();
              }
            } else if (res.data.code === 404) {
              snackbar.showSnackBar(res.data.data, "error");
            } else if (res.data.code === 400) {
              snackbar.showSnackBar(res.data.data, "error");
            } else {
              snackbar.showSnackBar(
                "Request item has not been approved successfully.",
                "error"
              );
            }
            confirmPopupService.hidePopup();
          }
        })
        .catch((err) => {
          snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
          confirmPopupService.hidePopup();
        });
  };

  const handleapproveRequest = async (
      requestWithItem: any,
      newStatus: any,
      createdUserEmail: string,
      CreatedUserName: string,
      behalfUserName?: string
    ) => {
      confirmPopupService.showPopup(
        "Are you sure you want to approve all items on this request?",
        () => {
          approveRequest(
            requestWithItem,
            newStatus,
            createdUserEmail,
            CreatedUserName,
            behalfUserName
          );
        }
      );
    };
  
    const approveRequest = (
      requestWithItem: any,
      newStatus: string,
      createdUserEmail: string,
      createdUserName: string,
      behalfUserName?: string
    ) => {
      const {
        processedItems,
        ItemsWithGeneralHardwareRequest,
        ItemsWithoutGeneralHardwareRequest,
      } = processRequestItems(
        requestWithItem?.items,
        createdUserEmail,
        createdUserName,
        behalfUserName
      );
  
      const cXMlRequestPayload = ITCatalogOrderXMLCompomnent(
        processedItems,
        `${uStore.getUser().firstName} ${uStore.getUser().lastName}`,
        uStore.getUser().userEmail
      );
  
      UserRequestListService.ChangeCurrentRequestStatus(
        requestWithItem,
        newStatus,
        uStore.getUser().userEmail,
        null,
        cXMlRequestPayload,
        ItemsWithGeneralHardwareRequest,
        ItemsWithoutGeneralHardwareRequest
      )
        .then((res: any) => {
          if (res) {
            if (res.data.code === 200) {
              if (refreshPendingApprovalsRef.current) {
                refreshPendingApprovalsRef.current();
              }
              snackbar.showSnackBar(res.data.data, "success");
            } else {
              snackbar.showSnackBar(
                res.data.data || "All items of request have not been approved.",
                "error"
              );
            }
            confirmPopupService.hidePopup();
          }
        })
        .catch((err) => {
          confirmPopupService.hidePopup();
          console.log(err);
          snackbar.showSnackBar(err.response.data, "error");
        });
  };

  const deniedRequest = (
      requestWithItem: any,
      newStatus: string,
      deniedReason: string,
      handleCloseDialog: () => void
    ) => {
      UserRequestListService.ChangeCurrentRequestStatus(
        requestWithItem,
        newStatus,
        uStore.getUser().userEmail,
        deniedReason
      )
        .then((res: any) => {
          if (res) {
            handleCloseDialog();
            if (res.data.code === 200 && res.data.data === "success") {
              if (refreshPendingApprovalsRef.current) {
                refreshPendingApprovalsRef.current();
              }
              snackbar.showSnackBar(
                "All items of request have been denied successfully.",
                "success"
              );
            } else if (res.data.code === 404) {
              snackbar.showSnackBar(res.data.data, "error");
            } else if (res.data.code === 400) {
              snackbar.showSnackBar(res.data.data, "error");
            } else {
              snackbar.showSnackBar(
                "All items of request has not been denied.",
                "error"
              );
            }
          }
        })
        .catch((err) => {
          handleCloseDialog();
          snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
        });
    };

  const addNotes = (
      requestId: any,
      noteText: string,
      handleCloseDialog: () => void
  ) => {
    const userName = uStore.getUser().userEmail;
    UserRequestListService.AddNoteForRequest(requestId, noteText, userName)
      .then((res: any) => {
        if (res) {
          handleCloseDialog();
          if (res.data.code === 200 && res.data.data === "success") {
            if (refreshPendingApprovalsRef.current) {
              refreshPendingApprovalsRef.current();
            }
            snackbar.showSnackBar(
              "Note has been added successfully.",
              "success"
            );
          } else if (res.data.code === 404) {
            snackbar.showSnackBar(res.data.data, "error");
          } else {
            snackbar.showSnackBar("Note has not been added.", "error");
          }
        }
      })
      .catch((err) => {
        handleCloseDialog();
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
      });
  };
  

  useEffect(() => {
    setIsloading(false);
  }, []);

  const handleCloseShowNotePopup = (isShowPopup: boolean) => {
    SetOpenShowNotePopup(isShowPopup);
  };

  const changeStartDateForNewEmployee = (
      date: any,
      formDetailsWithTitle: any,
      formData: any,
      selectedItemId: any,
      selectedRequestId: any
    ) => {
      const newFormDetailsWithTitle = JSON.parse(formDetailsWithTitle);
      const updatedformDetailsWithTitle: any = { ...newFormDetailsWithTitle };
  
      updatedformDetailsWithTitle["Start Date"] = date;
  
      const newFormData = JSON.parse(formData);
      const updateFormData: any = { ...newFormData };
      updateFormData["CustomColumn64sr"] = new Date(date).getTime().toString();
  
      UserRequestListService.UpdateStartDateIntoItemFormDetails(
        selectedRequestId,
        selectedItemId,
        updatedformDetailsWithTitle,
        updateFormData
      )
        .then((res: any) => {
          if (res) {
            if (res && res.data.code === 200) {
              handleCloseShowItemDetialsPopup(false);
              snackbar.showSnackBar(res.data.data, "success");
            } else {
              handleCloseShowItemDetialsPopup(false);
              snackbar.showSnackBar(res.data.data, "error");
            }
          }
        })
        .catch((err) => {
          snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
        });
  };

  const handleCancelRequest = async (id: any) => {
    confirmPopupService.showPopup(
      "Are you sure you want to cancel this request? You will not be able to recover it once it is cancelled.",
      () => {
        handleCanceledRequest(id);
      }
    );
  };

  const handleCanceledRequest = async (id: any) => {
    let res = await UserRequestListService.CancelRequestList(id);
    if (res.data) {
      if (res.data.code === 200 && res.data.data === "success") {
        snackbar.showSnackBar(
          "Your request has been canceled successfully.",
          "success"
        );
        if (refreshPendingApprovalsRef.current) {
          refreshPendingApprovalsRef.current();
        }
      } else {
        snackbar.showSnackBar("Your request has not been cancele", "error");
      }
    } else {
      snackbar.showSnackBar("Internal server error.", "error");
    }
    confirmPopupService.hidePopup();
  };

  const handleCancelItemOfRequest = async (requestId: any, itemId: any) => {
    confirmPopupService.showPopup(
      "Are you sure you want to cancel this item from request? You will not be able to recover it once it is cancelled.",
      () => {
        handleCancelItemOfRequest(requestId, itemId);
      }
    );
  };

  const handleCloseShowItemDetialsPopup = (isShowPopup: boolean) => {
    SetOpenShowItemDetailsPopup(isShowPopup);
  };

  return (
    <>
      <div className="breadcumDiv">
        {uStore.getUser().role === "Administrator" ? (
          <Breadcrumbs separator={<ArrowForwardIosIcon />} aria-label="breadcrumb">
            <span className="active-breadcumb">Pending Approvals</span>
          </Breadcrumbs>
        ) : (
          <Breadcrumbs separator={<ArrowForwardIosIcon />} aria-label="breadcrumb">
            <NavLink to="/search" title="Make A Request">
              Make A Request
            </NavLink>
            <span className="active-breadcumb">Pending Approvals</span>
          </Breadcrumbs>
        )}
      </div>
      <Navbar title="Pending Approvals" setPendingRequests={setPendingRequests} refreshPendingApprovalsRef={refreshPendingApprovalsRef} />
      <Card sx={{ mt: 3, p: 2, width: "100%", textAlign: "start", boxShadow: "none" }}>
        <CardContent>
          {isLoading ? (
            <Loader />
          ) : (
      <div style={{ width: '100%', overflowX: 'auto' }}>
        {filteredPendingRequests && filteredPendingRequests.length > 0 ? (
          <TableContainer component={Paper}>
            <Table style={{ minWidth: 650 }} aria-label="pending requests table">
              <TableHead>
                <TableRow style={{ background: '#f5f5f5' }}>
                  <TableCell>Request ID</TableCell>
                  <TableCell>Requested By</TableCell>
                  <TableCell>Requested Date</TableCell>
                  <TableCell>Item Categories</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>On Behalf Of</TableCell>
                  <TableCell>Notes</TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredPendingRequests.map((list: any) => {
                  const hasBehalf = !!list.behalfUserName;
                  const hasNotes = list.request_Notes && list.request_Notes.length > 0;
                  return (
                    <React.Fragment key={list.id}>
                      <TableRow hover style={{ background: '#fff' }}>
                        <TableCell>{list.id}</TableCell>
                        <TableCell>{list.createdUserName}</TableCell>
                        <TableCell>{ConvertDate(list.createdDate)} @ {GetTime(list.createdDate)}</TableCell>
                        <TableCell>{Array.from(new Set(list.items.map((item: any) => item.itemSubCategory))).join(', ')}</TableCell>
                        <TableCell>
                          {list.status === 'Pending' && <span><b>Status:</b> Pending</span>}
                          {list.status === 'Approved' && (
                            <span style={{ color: 'green', fontWeight: 600 }}>
                              <img className='ApprovedDeniedIcon' src={ApprovedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Approved
                            </span>
                          )}
                          {list.status === 'Denied' && (
                            <span style={{ color: 'red', fontWeight: 600 }}>
                              <img className='ApprovedDeniedIcon' src={DeniedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Denied
                            </span>
                          )}
                        </TableCell>
                        <TableCell>{hasBehalf ? list.behalfUserName : ''}</TableCell>
                        <TableCell>
                          {hasNotes ? (
                            <Tooltip
                              title={<span style={{ whiteSpace: 'pre-line', fontSize: '1.25rem', padding: 8, display: 'block', lineHeight: 1.5 }}>{list.request_Notes.map((n: any) => n.note || n).join('\n')}</span>}
                              placement="top"
                              arrow
                              PopperProps={{
                                modifiers: [
                                  {
                                    name: 'offset',
                                    options: {
                                      offset: [0, 8],
                                    },
                                  },
                                ],
                                sx: { '& .MuiTooltip-tooltip': { maxWidth: 400, padding: 2 } }
                              }}
                            >
                              <span>
                                <InfoIcon style={{ color: '#1976d2', verticalAlign: 'middle', cursor: 'default' }} />
                              </span>
                            </Tooltip>
                          ) : ''}
                        </TableCell>
                        <TableCell>
                          {uStore.getUser().role !== 'HR' && (
                            <PendingRequestThreeDots
                              list={list}
                              deniedRequest={(requestWithItem, newStatus, deniedReason, handleCloseDialog) => {
                                deniedRequest(requestWithItem, newStatus, deniedReason, handleCloseDialog);
                              }}
                              approveRequest={(requestWithItem, newStatus, createdUserEmail, CreatedUserName) => {
                                handleapproveRequest(requestWithItem, newStatus, createdUserEmail, CreatedUserName, requestWithItem.behalfUserName);
                              }}
                                addNotes={(id, noteText, handleCloseDialog) => {
                                addNotes(id, noteText, handleCloseDialog);
                              }}
                              handleCancelRequest={(id) => handleCancelRequest(id)}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => handleExpandClick(list.id)}
                          >
                            {expandedRows && expandedRows[list.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                          <Collapse in={expandedRows && expandedRows[list.id]} timeout="auto" unmountOnExit>
                            <Box margin={2}>
                              <Table size="small" aria-label="items">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Item ID</TableCell>
                                    <TableCell>Item Description</TableCell>
                                    {list.items.some((item: any) => item.itemSubCategory === "Employee Life Cycle") ? (
                                        <TableCell>Employee Name</TableCell>
                                    ) : null}
                                    <TableCell>Status</TableCell>
                                    <TableCell>Denied Reason</TableCell>
                                    <TableCell>Details</TableCell>
                                    <TableCell>Actions</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {list.items.map((item: any) => {
                                    const hasDeniedReason = item.status === 'Denied' && item.deniedReason;
                                    return (
                                      <TableRow key={item.requestItemID}>
                                        <TableCell>{item.requestItemID}</TableCell>
                                        <TableCell>{item.description}</TableCell>
                                        {list.items.some((itm: any) => itm.itemSubCategory === "Employee Life Cycle") ? (
                                            <TableCell>
                                                {item.itemSubCategory === "Employee Life Cycle" ? (() => {
                                                    let details: any = {};
                                                    try {
                                                        details = JSON.parse(item.formDataWithTitle);
                                                    } catch {}
                                                    if (typeof details === 'object' && details !== null) {
                                                        if (details["Employee Name"]) {
                                                            return details["Employee Name"];
                                                        }
                                                    }
                                                    return "N/A";
                                                })() : ""}
                                            </TableCell>
                                        ) : null}
                                        <TableCell>
                                          {item.status === 'Pending' && <span><b>Status:</b> Pending</span>}
                                          {item.status === 'Approved' && (
                                            <span style={{ color: 'green', fontWeight: 600 }}>
                                              <img className='ApprovedDeniedIcon' src={ApprovedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Approved
                                            </span>
                                          )}
                                          {item.status === 'Denied' && (
                                            <span style={{ color: 'red', fontWeight: 600 }}>
                                              <img className='ApprovedDeniedIcon' src={DeniedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Denied
                                            </span>
                                          )}
                                        </TableCell>
                                        <TableCell>
                                          {hasDeniedReason ? (
                                            <Tooltip
                                              title={<span style={{ whiteSpace: 'pre-line', fontSize: '1.1rem', padding: 8, display: 'block', lineHeight: 1.5 }}>{item.deniedReason}</span>}
                                              placement="top"
                                              arrow
                                              PopperProps={{
                                                modifiers: [
                                                  {
                                                    name: 'offset',
                                                    options: {
                                                      offset: [0, 8],
                                                    },
                                                  },
                                                ],
                                                sx: { '& .MuiTooltip-tooltip': { maxWidth: 400, padding: 2 } }
                                              }}
                                            >
                                              <span>
                                                <InfoIcon style={{ color: '#1976d2', verticalAlign: 'middle', cursor: 'default' }} />
                                              </span>
                                            </Tooltip>
                                          ) : ''}
                                        </TableCell>
                                        <TableCell>
                                          {item.formDataWithTitle && (
                                            <InfoIcon
                                              onClick={() => {
                                                SetOpenShowItemDetailsPopup(true);
                                                SetSelectedItemFormDetails(item.formDataWithTitle);
                                                SetselectedItemDetails(item);
                                                SetselectedRequestId(list.id);
                                              }}
                                              style={{ height: '30px', width: '24px', cursor: 'pointer', verticalAlign: 'middle' }}
                                            />
                                          )}
                                        </TableCell>
                                        <TableCell>
                                            <PendingRequestItemsKenbanMenu
                                              list={list}
                                              item={item}
                                              deniedItemOfRequest={(requestId, item, deniedReason) => {
                                                deniedItemOfRequest(requestId, item, deniedReason, () => setDenyDialogOpen(false));
                                              }}
                                              approveItemOfRequest={(requestId, item, newStatus, createdUserEmail, CreatedUserName) => {
                                                approveItemOfRequest(requestId, item, newStatus, createdUserEmail, CreatedUserName);
                                              }}
                                              handleCancelItemOfRequest={(requestId, itemId) => handleCancelItemOfRequest(requestId, itemId)}
                                            />
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <label className='noDataFoundMessage'> No Pending Request Found</label>
        )}
      </div>
          )}
        </CardContent>
      </Card>
      <ShowNotes
        requestNotes={selectedRequestNotes}
        isOpenDialog={OpenShowNotePopup}
        handleCloseShowNotePopup={(isShowPopup: any) => {
          handleCloseShowNotePopup(isShowPopup);
        }}
      />
      <ShowItemFormData
        selectedRequestId={selectedRequestId}
        selectedItemDetails={selectedItemDetails}
        changeStartDate={(date: any, formDetailsWithTitle: any, formData: any, selectedItemId: any, selectedRequestId: any) =>
          changeStartDateForNewEmployee(date, formDetailsWithTitle, formData, selectedItemId, selectedRequestId)
        }
        formDetails={selectedItemFormDetails}
        isOpenDialog={OpenShowItemDetailsPopup}
        handleCloseShowItemDetialsPopup={(isShowPopup: any) => {
          handleCloseShowItemDetialsPopup(isShowPopup);
        }}
      />
      {/* Approve Confirmation Dialog */}
      <Dialog open={approveDialogOpen} onClose={() => setApproveDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Approve Item</DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: '16px', marginTop: '8px' }}>
            Are you sure you want to approve this item?
          </div>
          {approveItem && approveItem.description === 'DISABLEDFORNOW' && (
            <div style={{ marginBottom: '16px' }}>
              <TextField
                label="Additional Info (required)"
                value={approveAdditionalInfo}
                onChange={e => setApproveAdditionalInfo(e.target.value)} 
                fullWidth
                multiline
                minRows={2}
                autoFocus
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApproveDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="success"
            disabled={approveItem && approveItem.description === 'DISABLEDFORNOW' && !approveAdditionalInfo.trim()}
            onClick={() => {
              approveItemOfRequest(
                approveRequestId,
                approveItem,
                'Approved',
                approveCreatedUserName,
                approveItem && approveItem.description === 'DISABLEDFORNOW' ? approveAdditionalInfo : null
              );
              setApproveDialogOpen(false);
              setExpandedRequestItems(expandedRequestItems.filter(item => item.id !== approveItem.id));
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>
      {/* Deny Reason Dialog */}
      <Dialog open={denyDialogOpen} onClose={() => setDenyDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Deny Item</DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: '16px', marginTop: '8px' }}>
            <TextField
              label="Reason for Denial"
              value={denyReason}
              onChange={e => setDenyReason(e.target.value)}
              fullWidth
              multiline
              minRows={2}
              autoFocus
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDenyDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            disabled={!denyReason.trim()}
            onClick={() => {
              deniedItemOfRequest(denyRequestId, denyItem, denyReason, () => setDenyDialogOpen(false));
              setExpandedRequestItems(expandedRequestItems.filter(item => item.id !== denyItem.id));
            }}
          >
            Deny
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PendingApprovals;
